import React from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';

import { Plus, Trash2 } from 'lucide-react';
import Textarea from '../../components/Textarea';
import Button from '../../components/Button';
import { KEY_ACTIVITIES_MAX_COUNT } from '../../utils/const';
import ConfirmationModal from '../../components/ConfirmationModal';

export default function KeyActivityCard({
  editMode,
  name,
  className,
  card: { steps, step },
  locales: { common, keyActivity },
  textColor,
  textStyle,
  background,
  buttonStyle,
  circleColor,
  lineColor,
  buttonVariant = 'outline',
}) {
  const {
    keyActivity: { addKeyActivity, updateKeyActivity, removeKeyActivity },
  } = useDispatch();

  return (
    <div className={classNames('bmc-page-keycard-wrapper', className)}>
      <div className="bmc-page-keycard" style={{ backgroundColor: background }}>
        <div className="bmc-page-keycard-steps bmc-page-keycard-steps--vertical">
          {steps.map((item, index) => (
            <div key={item.id} className="bmc-page-keycard-step">
              <div
                className={`bmc-page-keycard-step-title ${textStyle} custom-font-body`}
                style={{ color: textColor }}
              >
                {item.title || `${step} ${index + 1}`}
              </div>

              {editMode ? (
                <>
                  <div
                    className="circle-activity"
                    style={{ backgroundColor: circleColor }}
                  />
                  <div
                    className="line-activity"
                    style={{ backgroundColor: lineColor }}
                  />
                  <div className="flex flex-row items-center">
                    <Textarea
                      value={item.description}
                      delay={700}
                      className={`bmc-form-textarea ${textStyle} custom-font-body`}
                      onChange={(e) =>
                        updateKeyActivity({
                          id: item.id,
                          name: 'description',
                          value: e.target.value,
                        })
                      }
                      placeholder={keyActivity.steps.tabs.placeholder[index]}
                    />

                    {steps.length > 1 && (
                      <ConfirmationModal
                        className="ml-3 hover:bg-muted-lighter/60 text-muted-darker"
                        body={common.deleteConfirmation}
                        confirmText="Delete"
                        onConfirm={() => removeKeyActivity({ id: item.id })}
                        buttonAriaLabel="Delete"
                      >
                        <Trash2 className="w-6 min-w-6 h-auto" />
                      </ConfirmationModal>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div
                    className="circle-activity"
                    style={{ backgroundColor: circleColor }}
                  />
                  <div
                    className="line-activity"
                    style={{ backgroundColor: lineColor }}
                  />
                  <div
                    className={`bmc-page-keycard-step-text ${textStyle} custom-font-body`}
                    style={{ color: textColor }}
                  >
                    {item.description}
                  </div>
                </>
              )}
            </div>
          ))}
        </div>

        {editMode && steps.length < KEY_ACTIVITIES_MAX_COUNT && (
          <Button
            variant={buttonVariant}
            onClick={addKeyActivity}
            className={`w-full bg-transparent ${buttonStyle}`}
          >
            <Plus className="w-7 h-auto" />
            {`${common.create} ${name}`}
          </Button>
        )}
      </div>
    </div>
  );
}
